// function loadMarkdownEnFiles() {
//     const context = require.context('/public/en/docs', true, /\.md$/); // 加载 markdown 文件夹下的所有 .md 文件
//     const files = context.keys().map((key) => ({
//       path: key.replace(/^\./, ''), // 移除开头的点号
//       name: key.split('/').pop().replace('.md', ''), // 提取文件名
//     }));
//     console.log('Loaded files:', files); // 添加日志查看可用文件
//     return files;
// }


//写死顺序
function loadMarkdownEnFiles() {
    return [
      {
        path: '/Focus.md',
        name: 'Focus'
      },
      {
        path: '/Monitoring.md',
        name: 'Monitoring'
      },
      {
        path: '/Statisitcs.md',
        name: 'Statisitcs'
      },
      {
        path: '/GenR Membership Agreement.md',
        name: 'GenR Membership Agreement'
      },
      {
        path: '/GenR Privacy Policy.md',
        name: 'GenR Privacy Policy'
      },
      {
        path: '/GenR User Agreement.md',
        name: 'GenR User Agreement'
      }
    ]
}

export default loadMarkdownEnFiles;